import { Link } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import { Button } from "../components/Buttons";

export default function NotFound() {
    return (
        <Stack sx={{ alignItems: "center", justifyContent: "center", gap: 2, py: 10 }}>
            <Typography variant="h4">404</Typography>
            <Typography sx={{ color: "var(--text-secondary)" }}>
                That page doesn't exist.
            </Typography>
            <Link to="/dashboard">
                <Button variant="contained" color="primary">
                    Back to dashboard
                </Button>
            </Link>
        </Stack>
    );
}
